export default "__VITE_ASSET__CPBff9gx__"